import axios from 'axios'
import store from '@/store/store'
const config = require('../../../config/config.json')
const dotenv = require('dotenv')
dotenv.config()


export default () => {
    if (process.env.NODE_ENV === 'development') {
        let instance = axios.create({
            baseURL: "http://127.0.0.1:" + config.developmentServerPort,
            headers: {
                Authorization: `Bearer ${store.state.token}`,
                apikey: `${store.state.orgToken}`,
                route: `${store.state.currentRoute}`
            }
        })
        instance.interceptors.response.use(function(response) {
            return response;
        }, function(error) {

            if (401 === error.response.status || 440 === error.response.status) {
                window.location = '/login';
            }
            return Promise.reject(error);
        });
        return instance
    } else if (process.env.NODE_ENV === 'staging') {
        let instance = axios.create({
            baseURL: config.stagingApi,
            headers: {
                Authorization: `Bearer ${store.state.token}`,
                apikey: `${store.state.orgToken}`,
                route: `${store.state.currentRoute}`
            },
        })
        instance.interceptors.response.use(function(response) {
            return response;
        }, function(error) {

            if (401 === error.response.status || 440 === error.response.status) {
                window.location = '/login';
            }
            return Promise.reject(error);
        });
        return instance
    } else if (process.env.NODE_ENV === 'production') {
        let instance = axios.create({
            baseURL: config.productionApi,
            headers: {
                Authorization: `Bearer ${store.state.token}`,
                apikey: `${store.state.orgToken}`,
                route: `${store.state.currentRoute}`
            },
        })
        instance.interceptors.response.use(function(response) {
            return response;
        }, function(error) {

            if (error && error.response401 === error.response.status || 440 === error.response.status) {
                window.location = '/login';
            } else {
                console.log(error)
            }
            return Promise.reject(error);
        });
        return instance
    }
}